var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPagueCobranca(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 23.25,
    stroke: "#239C39",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 14C18.48 14 14 18.48 14 24C14 29.52 18.48 34 24 34C29.52 34 34 29.52 34 24C34 18.48 29.52 14 24 14ZM25.41 30.09V32H22.74V30.07C21.03 29.71 19.58 28.61 19.47 26.67H21.43C21.53 27.72 22.25 28.54 24.08 28.54C26.04 28.54 26.48 27.56 26.48 26.95C26.48 26.12 26.04 25.34 23.81 24.81C21.33 24.21 19.63 23.19 19.63 21.14C19.63 19.42 21.02 18.3 22.74 17.93V16H25.41V17.95C27.27 18.4 28.2 19.81 28.26 21.34H26.3C26.25 20.23 25.66 19.47 24.08 19.47C22.58 19.47 21.68 20.15 21.68 21.11C21.68 21.95 22.33 22.5 24.35 23.02C26.37 23.54 28.53 24.41 28.53 26.93C28.52 28.76 27.15 29.76 25.41 30.09Z",
    fill: "#239C39"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPagueCobranca);
export default __webpack_public_path__ + "static/media/icon-pague-cobranca.1c46a56ef1866c8a27220a95ca9b085a.svg";
export { ForwardRef as ReactComponent };